export interface ApiError {
  code: string;
  message: string;
}

export const isApiError = (error: unknown): error is ApiError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    typeof (error as ApiError).code === 'string' &&
    typeof (error as ApiError).message === 'string'
  );
};

// list of translation keys for API errors
// t('apiErrors.UNKNOWN_ERROR', 'Erreur inconnue')
// t('apiErrors.EVENT_OVERLAP', "La période sélectionnée est déjà réservée pour un autre événement qui ne peut pas être superposé. Veuillez choisir un autre créneau ou désélectionnez l'occupation exclusive du bien.")
// t('apiErrors.EMAIL_NOT_LINKED_TO_TOKEN', "Votre adresse mail n'est pas liée à cette invitation")
// t('apiErrors.INVITATION_FOR_EMAIL_EXISTS', 'Une invitation est déjà en attente pour cet email')
// t('apiErrors.INVALID_TOKEN', "Invitation invalide")
// t('apiErrors.TOKEN_ALREADY_USED', "Invitation déjà utilisée")
// t('apiErrors.EXPIRED_INVITATION', "Invitation expirée")
// t('apiErrors.NOT_THE_OWNER', "Vous n'êtes pas super administrateur du bien")
// t('apiErrors.ALREADY_MEMBER', "Cet email est déjà associée à un membre du bien")
// t('apiErrors.UNAUTHORIZED_FILETYPE', "Ce type de fichier n'est pas autorisé")
// t('apiErrors.EMAIL_NOT_ALLOWED', "Cet email n'appartient pas au domaine autorisé. Pour vous inscrire avec cette adresse, vous devez avoir reçu une invitation.")
// t('apiErrors.FILE_IN_USE', "Ce fichier/dossier est lié dans un autre élément, il ne peut pas être supprimé.")
// t('apiErrors.EXPIRED_OR_NON_EXISTING_EXPORT', "Cet export a expiré ou a été supprimé par son créateur")
// t('apiErrors.INVALID_RESET_PASSWORD_TOKEN', "Ce lien a expiré ou a déjà été utilisé")
// t('apiErrors.EMAIL_ALREADY_EXISTS', "Cet email est déjà utilisé")
// t('apiErrors.MISSING_PERMISSIONS', "Vous n'avez pas les droits pour effectuer cette opération, veuillez contacter l'administrateur du bien.")
// t('apiErrors.ASSET_ARCHIVED', "Le bien est archivé, veuillez le désarchiver avant de continuer.")
// t('apiErrors.QUOTA_EXCEEDED_STORAGE', "Vous avez atteint la limite de stockage du bien.")
// t('apiErrors.QUOTA_EXCEEDED_VIDEO_MINUTES', "Vous avez atteint la limite de stockage vidéo du bien. Supprimez des vidéos pour libérer de l'espace.")
// t('apiErrors.BANK_ACCOUNT_IN_USE', "Ce compte bancaire ne peux pas être supprimé car il est utilisé dans au moins une dépense ou recette")
// t('apiErrors.ASSET_READONLY_BECAUSE_QUOTA_REACHED', "Le bien est en lecture seule car il dépasse sa limite de stockage.")
// t('apiErrors.REIMBURSEMENT_AMOUNT_MISMATCH', "Le montant du remboursement ne correspond pas aux dépenses sélectionnées.")
// t('apiErrors.REIMBURSEMENT_MIXED_CASE', "Un même remboursement ne peut pas mêler des dépenses où vous participez et des dépenses où vous ne participez pas.")
// t('apiErrors.REIMBURSEMENT_BY_PARTICIPANT_UNSUPPORTED', "Ce remboursement ne peut pas être enregistré par un participant de la dépense.")
// t('apiErrors.REIMBURSEMENT_EXPENSE_NOT_ELIGIBLE', "Une des dépenses sélectionnées ne peut pas être remboursée par ce transfert.")
